<template>
  <div class="page-matchs">
    <!-- 隐藏 div-->
    <div class="common-type-list" style="display: none">
      <router-link to="/activities/collect?plate=2" class="type-item active"
        >日常活动</router-link
      >
      <router-link to="/activities/matchs?plate=3" class="type-item ">大赛活动</router-link>
    </div>
    <!-- 隐藏 div-->
    <div class="common-width-select clearfix" style="display: none">
       <div class="paeparation">
        <div class="search">
          <el-input class="ipt" clearable size="large" v-model="searchIpt" placeholder="请输入课程名称" ></el-input>
          <div class="btn" @click="getActivityList(1)">
            <i class="el-icon-search" ></i> 搜索
          </div>
        </div>
        <div class="types-list">
          <div class="type-item clearfix">
            <div class="tit">项目类型：</div>
            <ul class="cases clearfix">
              <li :class="productionType==0?'active':''" @click="selectProductionType(0)">全部</li>
              <li :class="productionType==item.id?'active':''"  @click="selectProductionType(item.id)" v-for="(item,index) in tagList" :key="index">{{item.tag}}</li>
            </ul>
          </div>
        </div>
      </div>
      <el-dropdown class="drop-down">
        <el-button type="primary">
          {{ selectTypes[selectTypesIndex]
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in selectTypes"
            :key="index"
            @click.native="selectType(index)"
            >{{ item }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>


    <el-dialog
      title="分享到"
      class="common-dialog"
      :visible.sync="dialogVisibleShare"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      append-to-body
    >
      <ul class="dialog-share-list clearfix">
        <li>
          <div class="img-f" @click="shareMy">
            <img :src="require('@/assets/images/share_01.png')" alt="" />
          </div>
          <p>我的动态</p>
        </li>
        <li @click="shareWechat">
          <div class="img-f">
            <img :src="require('@/assets/images/share_02.png')" alt="" />
          </div>
          <p>微信</p>
        </li>
        <li @click="shareWeibo">
          <div class="img-f">
            <img :src="require('@/assets/images/share_03.png')" alt="" />
          </div>
          <p>微博</p>
        </li>
        <li @click="shareQQzone">
          <div class="img-f">
            <img :src="require('@/assets/images/share_04.png')" alt="" />
          </div>
          <p>QQ空间</p>
        </li>
        <!--                <li>-->
        <!--                    <div class="img-f">-->
        <!--                        <img :src="require('@/assets/images/share_05.png')" alt="">-->
        <!--                    </div>-->
        <!--                    <p>生成海报</p>-->
        <!--                </li>-->
        <li @click="copyLink">
          <div class="img-f">
            <img :src="require('@/assets/images/share_06.png')" alt="" />
          </div>
          <p>复制链接</p>
        </li>
        <!-- <li>
                  <div class="img-f">
                    <img :src="require('@/assets/images/share_01.png')" alt="">
                  </div>
                  <p>收藏</p>
                </li> -->
      </ul>
      <el-dialog
        title="分享到微信"
        class="common-dialog"
        :visible.sync="dialogVisibleShareWechat"
        :close-on-click-modal="false"
        append-to-body
      >
        <div ref="qrcode" id="qrcode" class="dialog-share-wechat"></div>
      </el-dialog>
    </el-dialog>
    <div class="activities-content" v-loading="fullscreenLoading">
      <div
        class="active-item-one"
        v-for="(item, index) in activityList"
        :key="index"
      >
        <div class="act-time">活动时间：{{ item.showTime }}</div>
        <div class="act-infos">
          <div class="zpzj-tit">
            <router-link :to="'/activities/matchs/detail?id='+item.id+'&plate='+item.belongSection+''">{{
              item.activityName
            }}</router-link>
          </div>
          <div class="zc-count clearfix">
            <!--            <i class="icon see"></i><span class="much">666</span>-->
            <i
              class="icon zan"
              v-on:click="likeEvent(item.id, index,item.belongSection)"
              v-if="!item.likeFlag"
            ></i
            ><span class="much" v-if="!item.likeFlag">{{
              item.likeCount
            }}</span>
            <!--            <i class="icon fenxiang"  @click="share"></i><span class="much">{{item.shareCount}}</span>-->
            <i
              class="icon zan active"
              v-on:click="likeEvent(item.id, index,item.belongSection)"
              v-if="item.likeFlag"
            ></i
            ><span class="much" v-if="item.likeFlag">{{ item.likeCount }}</span>
            <i
              class="icon fenxiang active"
              v-on:click="share(item.id, index,item.belongSection)"
            ></i
            ><span class="much">{{ item.shareCount }}</span>
            <span class="date">{{ item.formatDateStr }}</span>
          </div>
          <router-link
            :to="'/activities/matchs/detail?id='+item.id+'&plate='+item.belongSection+''"
            class="act-zhuti-img"
          >
            <img :src="item.activityImage" alt="" />
            <div class="act-zt wks" v-if="item.showStatus == '未开始'"></div>
            <div class="act-zt jxz" v-if="item.showStatus == '进行中'"></div>
            <div class="act-zt yjs" v-if="item.showStatus == '已结束'"></div>

<!--             <div class="m-type n-act chahua" v-if="item.showProType == '插画'">插画作品</div>-->
<!--             <div class="m-type n-act fenjing" v-if="item.showProType == '分镜设计'">分镜作品</div>-->
<!--&lt;!&ndash;             <div class="m-type n-act dongtu" v-if="item.showProType == '动图'">动图作品</div>&ndash;&gt;-->
<!--             <div class="m-type n-act jianji" v-if="item.showProType == '剪辑合成'">剪辑作品</div>-->
<!--             <div class="m-type n-act moxing" v-if="item.showProType == '模型制作'">模型作品</div>-->
<!--             <div class="m-type n-act donghua" v-if="item.showProType == '动画制作'">动画作品</div>-->
<!--             <div class="m-type n-act gushi" v-if="item.showProType == '故事'">故事作品</div>-->
<!--             <div class="m-type n-act juben" v-if="item.showProType == '脚本'">脚本作品</div>-->
          </router-link>
        </div>
      </div>
      <div class="pagintion-f">
        <el-pagination
          background
          @current-change="getActivityList"
          layout="prev, pager, next"
          :current-page="currentPage"
          :hide-on-single-page="true"
          :page-size="5"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import QRCode from "qrcodejs2";
import global_ from '@/api/global'
import commentApi from '@/api/comment'
import productionApi from '@/api/production'
import archiveApi from '@/api/archive'
import apiService from '@/api/index'
import updateTdk from "@/utils/tdk";
export default {
    components: {

    },
    tdk() {
        return {
            title: this.headTitle,
            description: this.headDesc,
            keywords: this.headKeywords,
            ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com/collect">`
        };
    },
    serverPrefetch() {
        // this.setSeo();
        // updateTdk.call(this);
        // return true;
      this.getActivityList(1);
    },
    beforeRouteUpdate(to, from, next) {
        // 一般建议路由变更采用计算属性或者store直接绑定
        // 特殊情况处理可以采用如下方案 重新注册数据返回处理
        this.getActivityList(1);
        next();
    },
    data () {
        return {
            searchIpt: '',
            headTitle: "title---rrdh",
            headKeywords: "keywords---rrdh",
            headDesc: "description---rrdh",
            isMounted: false, //for control not ssr render

            shareIndex:"",
            shareId:"",
            belongSection:null,
            dialogVisibleShare: false,
            dialogVisibleShareWechat: false,
            selectTypesIndex: 0,
            selectTypes: ['全部', '进行中', '已结束','未开始'],
            activityList:[],
            total:0,
            index:0,
            currentPage:1,
            fullscreenLoading: true,
            shareUrl:"",
            shareUrl2:"",
            shareTitle:"",
            sharePic:"",
            tagList:[],
            productionType:0,
        }
    },
    beforeMount() {
        // 只会在浏览器执行Z
    },
    mounted() {
        let productionType=this.$route.query.productionType;
        console.log(productionType)
        if(productionType!=undefined&&productionType!=null&&productionType!=""){
          this.productionType=productionType;
        }
        this.isMounted = true;
        this.getActivityList(1)
        this.getTagList();
    },
    methods: {
      selectProductionType(id){
        this.productionType=id;
        this.getActivityList(1);
      },
        getTagList(){
          let _this=this;
          let url="/rrbi/tags/frontActivityTagList?ti="+new Date().getMilliseconds();
          _this.$axios.get(url).then(function(result){
            // console.log(result.data.response)
            _this.tagList=result.data.response;
            _this.toTop();
          })
        },
        setSeo(type) {
            this.headTitle = "作品征集——人人动画网【官网】";
            this.headKeywords = "作品征集,动画大赛,模型征集,原画征集,动画作品征集";
            this.headDesc ="人人动画网有奖征集活动，主要征集动画、模型、概念设计、场景、剪辑、人物设计、脚本类作品。";
        },
        selectType (index) {
            this.selectTypesIndex = index
            console.log(this.selectTypesIndex)
            this.getActivityList(1);
        },
        getActivityList(page){
            let startPage=page;
            this.currentPage=startPage;
            let _this=this;
            _this.fullscreenLoading = true
            let activityType=99;
            let status=_this.selectTypesIndex;
            let productionType=this.productionType;
            let activityName=this.searchIpt;
            let pageSize=5;
            let url="/rrbi/activity/activity-all?activityType="+activityType+"&publishStatus=1"+"&page="+startPage+"&pageSize="+pageSize+"&status="+status+"&from=front&ti="+new Date().getMilliseconds()+"&productionType="+productionType+"&activityName="+activityName;
            _this.$axios.get(url).then(function(result){
                _this.activityList=result.data.response.list;
                _this.total = result.data.response.total
                _this.fullscreenLoading = false
                _this.toTop();
            })
          this.setSeo();
          updateTdk.call(this);
        },
        share (id,index,belongSection) {
            let _this=this;
            _this.shareUrl="";
            _this.shareTitle="";
            _this.sharePic="";
            _this.shareId="";
            _this.belongSection=null;
            _this.dialogVisibleShare = true
            _this.shareIndex="";
            let url="/rrbi/activity/activity-one?id="+id+"&ti="+new Date().getMilliseconds();
            _this.$axios.get(url).then(function(result){
                console.log(result.data)
                if(result.data.code==1){
                    _this.shareUrl=encodeURIComponent("http://www.renrendonghua.com/activities/matchs/detail?id="+result.data.response.id+"&plate="+result.data.response.belongSection);
                    _this.shareUrl2="http://www.renrendonghua.com/activities/matchs/detail?id="+result.data.response.id+"&plate="+result.data.response.belongSection
                    _this.shareTitle="活动分享_"+result.data.response.activityName;
                    _this.sharePic=result.data.response.posterImage;
                    _this.shareId=result.data.response.id
                    _this.belongSection = belongSection
                    _this.dialogVisibleShare = true
                    _this.shareIndex=index;
                    console.log(_this.shareIndex)
                }else{
                    _this.$router.push({
                        path:'/error',
                    })
                }

            })

        },
        toTop () {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        },
        likeEvent(id,index,belongSection){
            console.log(index)
            let _this =this;
            console.debug(_this.isLogin);
            if(_this.global.isLogin){
                apiService.dolike({"objectType":3,"objectId":id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    // _this.initData();
                    let url="/rrbi/activity/activity-one?id="+id+"&ti="+new Date().getMilliseconds()
                    _this.$axios.get(url).then(function(result){
                        let likeCount=result.data.response.likeCount
                        _this.activityList[index].likeCount=likeCount;
                        _this.activityList[index].likeFlag=result.data.response.likeFlag;
                    })
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                this.$router.push({
                    path: '/login?callback=http://www.renrendonghua.com/activities/collect',
                })
            }

        },
        disLikeEvent(id,index,belongSection){
            console.debug(id);
            let _this =this;
            if(_this.global.isLogin) {
                apiService.dislike({"objectType": 3, "objectId": id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    let url="/rrbi/activity/activity-one?id="+id+"&ti="+new Date().getMilliseconds()
                    _this.$axios.get(url).then(function(result){
                        let likeCount=result.data.response.likeCount
                        _this.activityList[index].likeCount=likeCount;
                    })
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                this.$router.push({
                    path: '/login?callback=http://www.renrendonghua.com/activities/collect',
                })
            }
        },
        shareMy(){
            let _this=this;
            if(!this.global.isLogin){
                this.$router.push({
                    path: '/login?callback=http://www.renrendonghua.com/activities/matchs/detail?id='+this.$route.query.id,
                })
                return false;
            }
            apiService.doshare({"objectType": 3, "objectId": this.shareId,"belongSection":this.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {

                let url="/rrbi/activity/activity-one?id="+_this.shareId+"&ti="+new Date().getMilliseconds()
                _this.$axios.get(url).then(function(result){
                    console.log(_this.shareIndex)
                    let shareCount=result.data.response.shareCount
                    _this.activityList[_this.shareIndex].shareCount=shareCount;
                    _this.dialogVisibleShare = false
                    _this.$message.success("成功分享到我的动态!!!!");
                })
            })
        },
        shareWechat () {
            let _this=this;
            this.dialogVisibleShareWechat = true
            apiService.doshare({"objectType": 3, "objectId": this.shareId,"belongSection":this.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
                let url="/rrbi/activity/activity-one?id="+_this.shareId+"&ti="+new Date().getMilliseconds()
                _this.$axios.get(url).then(function(result){
                    console.log(_this.shareIndex)
                    let shareCount=result.data.response.shareCount
                    _this.activityList[_this.shareIndex].shareCount=shareCount;
                    _this.$nextTick(() => {
                        document.getElementById("qrcode").innerHTML = "";
                        let uu=["a","b","c","d","e","f","g","h","i","j"]
                        let t=(new Date().getTime()+""+new Date().getMilliseconds()).toString().split('');
                        let uuid="";
                        t.forEach(function (e) {
                            uuid=uuid+uu[e]+"";
                        })
                        new _this.QRCode(_this.$refs.qrcode, {
                            width: 100,
                            height: 100,
                            text: "http://www.renrendonghua.com/postactivitypost/postactivity-v1?id="+_this.shareId+"&tme="+new Date().getMilliseconds()
                        })
                    })
                })

            })
        },
        shareWeibo () {
            let _this=this;
            apiService.doshare({"objectType": 3, "objectId": this.shareId,"belongSection":this.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
                let conturl="/rrbi/activity/activity-one?id="+_this.shareId+"&ti="+new Date().getMilliseconds()
                _this.$axios.get(conturl).then(function(result){
                    console.log(_this.shareIndex)
                    let shareCount=result.data.response.shareCount
                    _this.activityList[_this.shareIndex].shareCount=shareCount;
                    const url = _this.shareUrl
                    const title = _this.shareTitle
                    const pic = _this.sharePic
                    const appkey = '#_loginLayer_1578022321857'
                    const link = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}&appkey=${appkey}`
                    window.open(link)
                })

            })
        },
        shareQQzone () {
            let _this=this;
            apiService.doshare({"objectType": 3, "objectId": this.shareId,"belongSection":this.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
                let conturl="/rrbi/activity/activity-one?id="+_this.shareId+"&ti="+new Date().getMilliseconds()
                _this.$axios.get(conturl).then(function(result){
                    console.log(_this.shareIndex)
                    let shareCount=result.data.response.shareCount
                    _this.activityList[_this.shareIndex].shareCount=shareCount;
                    const url =_this.shareUrl
                    const title = _this.shareTitle
                    const desc = ''
                    const summary = ''
                    const pic =_this.sharePic
                    const site = '%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83'
                    const link = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&site=${site}&pics=${pic}`
                    window.open(link)
                })

            })
        },
        copyLink () {
            let Url2 = decodeURIComponent(this.shareUrl);
            let oInput = document.createElement("input");
            oInput.value = Url2;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.className = "oInput";
            oInput.style.display = "none";
            this.$message.success("复制成功");
        },
    }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
.page-matchs {
  padding-top: @NAVHEIGHT;
  .common-type-list {
    padding-top: 20px;
  }
}
.common-width-select{
  padding: 10px 0;
}
@media screen and (max-width: 750px) {
  .page-matchs {
    .common-type-list {
      padding-top: 5px;
      margin-bottom: 5px;
    }
  }
}
//@import "../../../assets/less/stylePublic.less";
</style>
